define("ember-composable-helpers/helpers/map", ["exports", "@ember/component/helper", "@ember/utils", "ember-composable-helpers/utils/as-array"], function (_exports, _helper, _utils, _asArray) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _exports.map = map;
  function map(_ref) {
    let [callback, array] = _ref;
    if ((0, _utils.isEmpty)(callback)) {
      return [];
    }
    return (0, _asArray.default)(array).map(callback);
  }
  var _default = _exports.default = (0, _helper.helper)(map);
});